/**
 * Self-service account endpoints (password, preferences).
 *
 * Backend was extended after first release with:
 *   POST /api/v1/users/me/password
 *   GET  /api/v1/users/me/preferences
 *   PUT  /api/v1/users/me/preferences
 *
 * These helpers are intentionally small and side-effect-free so any page
 * (Call Center profile, Customer profile, etc.) can call them directly.
 */

import { apiClient } from './api';

export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  await apiClient.post<void>('/users/me/password', { currentPassword, newPassword });
}

export interface UserPreferences {
  user_id: number;
  prefs: Record<string, unknown>;
  updated_at: string;
}

export async function getUserPreferences(): Promise<UserPreferences> {
  return apiClient.get<UserPreferences>('/users/me/preferences');
}

export async function saveUserPreferences(prefs: Record<string, unknown>): Promise<UserPreferences> {
  return apiClient.put<UserPreferences>('/users/me/preferences', { prefs });
}
